var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticStyle:{"text-align":"center"},attrs:{"plain":"","size":"medium","icon":"el-icon-upload"},on:{"click":_vm.handleUpload}},[_c('input',{ref:"excel-upload-input",staticClass:"excel-upload-input",attrs:{"type":"file"},on:{"change":_vm.handleClick}}),_c('span',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }